import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { MenuItem } from "@/components/ui/menu";
import { useRelativeTime } from "@/hooks/use-relative-time";
import { NAMESPACES } from "@/i18n/constants";
import { ICON_KEYS, iconRegistry } from "@/icons/icon-registry";
import { cn } from "@/utils/class-name";
import { useDataViewerStore } from "../data-viewer-provider";

const SPIN_ANIM_DURATION_MS = 500;
const RefreshIcon = iconRegistry[ICON_KEYS.REFRESH];

export function RefreshButton() {
    const { t } = useTranslation(NAMESPACES.FEATURES.DATA_VIEWER, { keyPrefix: "time-window.last-updated-bar" });
    const { t: tCommon } = useTranslation(NAMESPACES.COMMON);
    const endMs = useDataViewerStore((state) => state.endMs);
    const advanceWindowToNow = useDataViewerStore((state) => state.advanceWindowToNow);
    const { timeStringWithAgoSuffix } = useRelativeTime(endMs);
    const [isSpinning, setIsSpinning] = useState(false);

    useEffect(() => {
        if (!isSpinning) return undefined;
        const id = setTimeout(() => setIsSpinning(false), SPIN_ANIM_DURATION_MS);
        return () => {
            clearTimeout(id);
        };
    }, [isSpinning]);

    const handleRefresh = () => {
        if (isSpinning) return;
        setIsSpinning(true);
        advanceWindowToNow();
    };

    return (
        <Button
            // The label still names the action — the tooltip carries when the data is from.
            aria-label={tCommon("actions.refresh")}
            onClick={handleRefresh}
            size={"icon"}
            tooltip={t("label", { relativeTime: timeStringWithAgoSuffix })}
            tooltipDelay={0}
            variant={"outline"}
        >
            <RefreshIcon className={cn("size-[14px]", { "animate-spin": isSpinning })} />
        </Button>
    );
}

export function RefreshMenuItem() {
    const { t: tCommon } = useTranslation(NAMESPACES.COMMON);
    const advanceWindowToNow = useDataViewerStore((state) => state.advanceWindowToNow);

    return (
        <MenuItem onClick={advanceWindowToNow}>
            <RefreshIcon />
            {tCommon("actions.refresh")}
        </MenuItem>
    );
}
